import axios from "axios";

export async function WCSActivity() {
    try {
        const response = axios({url: "/acapi/jmx/wcs_instances"});
        return response;
    } catch (error) {
        console.log(error);
        throw Error();
    }
}

export async function StatisticsSummary(data) {
    try {
        const response = axios({url: "/acapi/statistics/summary", params: data});
        return response;
    } catch (error) {
        console.log(error);
        throw Error();
    }
}

export async function Transports() {
    try {
        const response = axios({url: "/acapi/transports"});
        return response;
    } catch (error) {
        console.log(error);
        throw Error();
    }
}

export async function PartnerConnectons(data) {
    try {
        const response = axios({url: "/acapi/partners/connections", params: data});
        return response;
    } catch (error) {
        console.log(error);
        throw Error();
    }
}

export async function ServiceProviderConnectons(data) {
    try {
        const response = axios({url: "/acapi/service_providers/connections", params: data});
        return response;
    } catch (error) {
        console.log(error);
        throw Error();
    }
}

export async function MessagesByGroup(data) {
    try {
        const response = axios({url: `/stats-api/group/${data.transport}`, params: data});
        return response;
    } catch (error) {
        console.log(error);
        throw Error();
    }
}

export async function MessageStatuses(data) {
    try {
        const response = axios({url: "/acapi/statistics/group/outgoing", params: data});
        return response;
    } catch (error) {
        console.log(error);
        throw Error();
    }
}

export async function TrafficSending(data) {
    try {
        const response = axios({url: "/acapi/statistics/group/traffic", params: data});
        return response;
    } catch (error) {
        console.log(error);
        throw Error();
    }
}
